(function () {
    angular
        .module('app.ocom')
        .directive('locationField', locationField);

    function locationField(focus) {
        return {
            restrict: 'AE',
            require: 'ngModel',
            transclude: true,
            scope: {
                item: '=',
                field: '@?',
                form: '=?',
                model: '@?',
                preview: '@?',
                disabled: '=?',
                required: '=?',
            },
            templateUrl: 'js/ocom/widgets/forms/location-field.html',
            controller: function ($scope) {
                if (!$scope.field) {
                    $scope.latField = "latitude";
                    $scope.longField = "longitude";
                } else {
                    $scope.latField = $scope.field + "_latitude";
                    $scope.longField = $scope.field + "_longitude";
                }

                $scope.canShowMap = function (latitude, longitude, latitude_error, longitude_error) {
                    return latitude != null && longitude != null && !latitude_error && !longitude_error;
                };

                $scope.openMap = function (latitude, longitude) {
                    window.open("https://www.google.com/maps/search/?api=1&query=" + latitude + "," + longitude);
                };
            }
        };
    }
})();
